var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"crowded"}},[_c('div',{staticClass:"crowded-box"},[_c('img',{attrs:{"src":require("@/assets/img/Special/crowded.png")}}),_c('h1',[_vm._v("系统太拥挤")]),_c('div',[_vm._v("活动太火爆了，系统目前过载了， 请您五分钟后再试一下")])])])
}]

export { render, staticRenderFns }